import React, { useState, useEffect } from "react";

import InputFieldDataProfile from "../../../components/InputFieldDataProfile";
import editIcon from "../../../img/pencil-icon.svg";
import saveIcon from '../../../img/save-icon.svg';
import cancelIcon from '../../../img/close-icon-button.svg';

import { validatePhoneNumber } from "../../../utils";
import { Button, Box } from "@mui/material";
import { useUpdateDataMutation } from '../../../services/accountsApi';

const UserMobileField = ({ user, setUser }) => {
  const [initUpdateData, {isLoading: updateDataIsLoading}] = useUpdateDataMutation();

  function PencilOrangeIconSvg() {
    return <img src={editIcon} alt="edit icon" height="18px" width="18px" />;
  }
  const [userInformation, setUserInformation] = useState({ ...user });
  const [error, setError] = useState(null);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setUserInformation((prev) => {
      return {
        ...user,
        mobilePhone: prev.mobilePhone
      }
    })
  }, [user])

  const closeEditForm = () => {
    setCanEdit(false);
  };

  async function sendData() {
    if (!error) {
      try {
        let res = await initUpdateData({id:user.id, body:userInformation}).unwrap();
        console.log(res);
        setUser(userInformation);
      } catch (error) {
        console.log("error updating user: " + error);
      }
      closeEditForm();
    }
  }

  useEffect(() => {
    if (userInformation) {
      if (!validatePhoneNumber(userInformation.mobilePhone)) {
        setError({ value: "phone", error: "Invalid Phone Number" })
      } else {
        setError(null)
      }
    }
  }, [userInformation]);

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <InputFieldDataProfile
          label="Mobile Phone"
          value={userInformation.mobilePhone}
          onChange={(e) => { setUserInformation((prevState) => { return { ...prevState, ['mobilePhone']: e.target.value } }) }}
          edit={canEdit}
          inputType="tel"
        />

        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "5px" }}>
          {canEdit && error?.value === "phone" ? <li style={{ color: "var(--red)", fontWeight: 600, fontSize: ".85rem", marginTop: "2em" }}>{error.error}</li> : null}
        </Box>
      </Box>
      <Box className="edit-button-container">
        {canEdit ? (
          <div className="container-button-form">
            <Button
              className="btn-save-form"
              onClick={sendData}
            >
              <img src={saveIcon} alt='Save Icon' height='18px' style={{ marginRight: '0.25em' }} />
              <span style={{ color: ' var(--orange) ' }}>Save</span>
            </Button>
            <Button className="btn-cancel-form" onClick={closeEditForm}>
              <img src={cancelIcon} alt='Cancel Icon' height='18px' style={{ marginRight: '0.25em' }} />
              <span style={{ color: ' var(--orange) ' }}>Cancel</span>
            </Button>
          </div>
        ) : (
          <Button
            className="button-edit"
            onClick={() =>
              setCanEdit(true)
            }
          >
            <PencilOrangeIconSvg />
            <span style={{ marginLeft: "0.5em", color: ' var(--orange) ' }}>Edit</span>
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default UserMobileField;
